import { ApiError, apiFetch } from '@/lib/api';

type GetToken = () => Promise<string | null>;

/**
 * Fetch a JPEG admin image preview as a blob URL.
 * Missing Spaces objects return 404 — treat that as "no preview" so Pulse /
 * vault / attachments can show their fallback instead of paging Sentry
 * (HARBOR-WEB-13).
 */
export async function fetchAdminImagePreview(
  getToken: GetToken,
  path: string,
): Promise<string | null> {
  const res = await apiFetch(getToken, path, {
    headers: { Accept: 'image/jpeg' },
  });
  if (res.status === 404) {
    return null;
  }
  if (!res.ok) {
    throw new ApiError('Preview failed', res.status);
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
